import { createSystem, defaultConfig, defineConfig } from '@chakra-ui/react';

// Brand color: #6C2888 with generated shades
const brandPurple = {
    50: '#f9f0fc',
    100: '#edd5f5',
    200: '#ddb0eb',
    300: '#c985dd',
    400: '#b560cf',
    500: '#6C2888', // Base brand color
    600: '#6C2888', // Primary usage
    700: '#5a2272',
    800: '#481c5c',
    900: '#361546',
    950: '#240e30',
};

const customConfig = defineConfig({
    theme: {
        tokens: {
            colors: {
                purple: brandPurple,
                brand: brandPurple,
            },
        },
    },
});

const theme = createSystem(defaultConfig, customConfig);

export default theme;
